<template>
  <div class="medicine">
    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h3>Sistema de gestão</h3>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.pacient.img1"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h3>Agendamento de consultas e exames on-line</h3>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.pacient.img2"
          />
        </figure>
      </el-col>
    </el-row>
    <div class="close-btn-text mt-5 mb-5" @click="$emit('close-service')">Fechar</div>
  </div>
</template>

<script>
export default {
  name: 'Pacient',
  props: ['data']
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.medicine {
  img {
    width: 100%;
  }
}

.medicine-titles {
  text-transform: uppercase;

  h3 {
    font-weight: bold;
    color: $blue;
    max-width: 60%;
    font-size: 3rem;
    line-height: 4rem;
  }

  h4 {
    font-size: 3rem;
    line-height: 4rem;
    color: $blue;
    font-weight: 300;
  }

  p {
    padding-top: 2rem;
    text-transform: none;
    width: 60%;
  }
}
</style>
